<template>
  <div class="eating-item">
    <div class="d-flex align-center">
      <p class="meal-label">{{ text }}</p>
      <v-menu v-model="showMenu" absolute offset-y max-width="290px">
        <template v-if="item" v-slot:activator="{ props }">
          <div class="d-flex flex-column align-center ml-5" v-bind="props">
            <div class="d-flex" style="position: relative">
              <div :class="`circle-back-${showMealStatus(item)}`"></div>
              <div :class="`circle-front-${showMealStatus(item)}`"></div>
            </div>
            <p class="meal-status-text body-2 text-grey">{{ showMealStatusText(item) }}</p>
          </div>
        </template>
        <v-list>
          <v-list-item v-for="(s, index) in statusList" :key="index">
            <v-list-item-title>
              <div class="d-flex align-center" @click="changeStatusItem(s.status)">
                <div class="d-flex flex-column align-center">
                  <div class="d-flex" style="position: relative">
                    <div :class="`circle-back-${s.status}`"></div>
                    <div :class="`circle-front-${s.status}`"></div>
                  </div>
                </div>
                <div class="ml-3 menu-item-text">{{ $t(s.titleKey) }}</div>
              </div>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>
<script lang="ts">
import Vue, { PropType, defineComponent } from 'vue';
import { MealStatus, MealStatusType } from 'chaild-api/lib';
import i18n from '@/plugins/i18n';

import { when } from '@/service/Switch';

export default defineComponent({
  props: {
    text: {
      type: String,
      required: true,
    },
    item:  {
      type: String as PropType<MealStatusType>,
    },
    field: {
      type: String as PropType<'stapleFood' | 'mainDish' | 'sideDish' | 'soup' | 'dessert' | 'milk' | 'snack'>,
      required: true,
    },
  },
  data: () => {
    return {
      showMenu: false,
      statusList: [
        { status: MealStatus.refill, titleKey: 'meal.status.refill' },
        { status: MealStatus.finished, titleKey: 'meal.status.finished' },
        { status: MealStatus.unfinished, titleKey: 'meal.status.unfinished' },
        { status: MealStatus.half, titleKey: 'meal.status.half' },
        { status: MealStatus.little, titleKey: 'meal.status.little' },
        { status: MealStatus.notEat, titleKey: 'meal.status.notEat' },
        { status: MealStatus.notServed, titleKey: 'meal.status.notServed' },
      ],
    };
  },
  computed: {},
  methods: {
    changeStatusItem(status: MealStatusType) {
      this.$emit('changeStatusItem', status, this.field);
    },
    showMealStatusText(status: MealStatusType): string {
      const temp = when(status)
        .on(
          v => v === MealStatus.refill,
          () => i18n.global.t('meal.status.refill')
        )
        .on(
          v => v === MealStatus.finished,
          () => i18n.global.t('meal.status.finished')
        )
        .on(
          v => v === MealStatus.unfinished,
          () => i18n.global.t('meal.status.unfinished')
        )
        .on(
          v => v === MealStatus.half,
          () => i18n.global.t('meal.status.half')
        )
        .on(
          v => v === MealStatus.little,
          () => i18n.global.t('meal.status.little')
        )
        .on(
          v => v === MealStatus.notEat,
          () => i18n.global.t('meal.status.notEat')
        )
        .on(
          v => v === MealStatus.notServed,
          () => i18n.global.t('meal.status.notServed')
        )
        .otherwise(() => '');
      return temp;
    },
    showMealStatus(status: MealStatusType): string {
      const temp = when(status)
        .on(
          v => v === MealStatus.refill,
          () => 'refill'
        )
        .on(
          v => v === MealStatus.finished,
          () => 'finished'
        )
        .on(
          v => v === MealStatus.unfinished,
          () => 'unfinished'
        )
        .on(
          v => v === MealStatus.half,
          () => 'half'
        )
        .on(
          v => v === MealStatus.little,
          () => 'little'
        )
        .on(
          v => v === MealStatus.notEat,
          () => 'notEat'
        )
        .on(
          v => v === MealStatus.notServed,
          () => 'notServed'
        )
        .otherwise(() => '');
      return temp;
    },
  },
  mounted: async function() {},
});
</script>
<style lang="scss" scoped>
.circle-back-notEat,
.circle-back-little,
.circle-back-half,
.circle-back-unfinished,
.circle-back-finished,
.circle-back-refill {
  height: 34px;
  width: 34px;
  border-radius: 100%;
  background-color: rgb(var(--v-theme-primary));
  margin-right: 10px;
}
.circle-back-notServed {
  height: 30px;
  width: 34px;
  background-color: white;
}
.circle-front-notEat {
  height: 30px;
  width: 30px;
  top: 2px;
  left: 2px;
  border-radius: 100%;
  background-color: white;
  position: absolute;
}

.circle-front-little {
  height: 22px;
  width: 30px;
  top: 2px;
  left: 2px;
  border-radius: 22px 22px 5px 5px;
  background-color: white;
  position: absolute;
}
.circle-front-half {
  height: 15px;
  width: 30px;
  top: 2px;
  left: 2px;
  border-radius: 15px 15px 0px 0px;
  background-color: white;
  position: absolute;
}

.circle-front-unfinished {
  height: 15px;
  width: 30px;
  top: 2px;
  left: 2px;
  border-radius: 15px 15px 0px 0px;
  background-color: white;
  position: absolute;
  // border-top: 3px solid #ff6c00;
  // border-right: 1px solid #ff6c00;
  border-bottom: 7px solid rgb(var(--v-theme-primary));
  // border-left: 1px solid #ff6c00;
}

.circle-front-finished {
  height: 30px;
  width: 30px;
  top: 1px;
  left: 1px;
  border-radius: 100%;
  background-color: rgb(var(--v-theme-primary));
  position: absolute;
}

.circle-front-refill {
  height: 34px;
  width: 34px;
  left: 7px;
  border-radius: 100%;
  background-color: rgb(var(--v-theme-primary));
  border: 1px solid white;
  position: absolute;
}

.circle-front-notServed {
  height: 5px;
  width: 34px;
  top: 17px;
  background-color: #c4c4c4;
  position: absolute;
}

.eating-item {
  .meal-row {
    gap: 0.5rem;
    
    @media (max-width: 480px) {
      gap: 0.375rem;
    }
    
    @media (max-width: 360px) {
      gap: 0.25rem;
    }
  }
  
  .meal-label {
    @media (max-width: 480px) {
      font-size: 0.8125rem;
      max-width: 40px;
    }
    
    @media (max-width: 375px) {
      font-size: 0.7rem;
      max-width: 35px;
    }
  }
  
  .meal-indicator {
    @media (max-width: 480px) {
      min-width: 2.25rem;
    }
    
    @media (max-width: 360px) {
      min-width: 2rem;
    }
  }
  
  .meal-status-text {
    @media (max-width: 480px) {
      font-size: 0.6875rem !important;
      max-width: 3.5rem;
      text-align: center;
      line-height: 1.2;
    }
    
    @media (max-width: 360px) {
      font-size: 0.625rem !important;
      max-width: 3rem;
    }
  }
}

// Menu item text responsive
.menu-item-text {
  @media (max-width: 480px) {
    font-size: 0.8125rem;
  }
}
</style>
